import {z} from 'zod';

import i18n from '@dms/i18n';

export const WorkSplittingFormTypeSchema = z.object({
  assignMechanics: z.array(
    z
      .object({
        id: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
        costCenterId: z.string().nullish(),
        ratio: z.number().min(0).max(100),
      })
      .nullish()
  ),
});

export type WorkSplittingFormType = z.infer<typeof WorkSplittingFormTypeSchema>;
